/**
 * Reads catalogue settings from IndexedDB (Dexie), refreshed reactively.
 * Returns null while loading, then the settings object.
 */

import { useState, useEffect } from 'react';
import { loadEffectiveSettings } from '../shared/services/db';
import type { CatalogueSettings } from '../shared/types';
import { DEFAULT_CATALOGUE_SETTINGS } from '../shared/types';

export function useLiveSettings(): CatalogueSettings {
  const [settings, setSettings] = useState<CatalogueSettings>(DEFAULT_CATALOGUE_SETTINGS);

  // Synced catalogue settings + the user's local branding override merged on top.
  const load = () => {
    loadEffectiveSettings().then(setSettings);
  };

  useEffect(() => {
    load();
    const onChanged = () => load();
    window.addEventListener('catalogue-settings-changed', onChanged);
    return () => window.removeEventListener('catalogue-settings-changed', onChanged);
  }, []);

  return settings;
}
